"use client";

import dynamic from "next/dynamic";
import { Skeleton } from "@/components/ui/skeleton";

const DetailMapView = dynamic(() => import("./detail-map-view"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full bg-secondary/5 flex items-center justify-center rounded-xl">
      <Skeleton className="w-full h-full rounded-xl" />
    </div>
  ),
});

// Legacy property format
interface LegacyProperty {
  id: string;
  name: string;
  location?: string;
  coordinates?: [number, number];
}

// Database property format
interface DatabaseProperty {
  id: number;
  name: string;
  location_name: string;
  latitude?: number | null;
  longitude?: number | null;
}

export type PropertyDetailInput = LegacyProperty | DatabaseProperty;

interface PropertyDetailMapProps {
  property: PropertyDetailInput;
  className?: string;
}

export function PropertyDetailMap(props: PropertyDetailMapProps) {
  return <DetailMapView {...props} />;
}
